import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { FileText } from "lucide-react";

export default function Packets() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/packets").then(r=>setItems(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="packets-page">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">Investor Deliverables</div>
        <h1 className="text-3xl font-bold">Information Packets</h1>
        <p className="text-xs text-slate-500 mt-1">Generate a packet from any property detail page (via a matching program).</p>
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
        {items.map(pk => (
          <Link to={`/packets/${pk.id}`} key={pk.id}>
            <Card className="p-5 border-slate-200 hover:border-slate-900 transition-colors h-full" data-testid={`packet-card-${pk.id}`}>
              <div className="flex items-center gap-2 mb-2 text-[10px] uppercase tracking-widest text-slate-500 font-semibold"><FileText className="w-3.5 h-3.5"/>Packet</div>
              <h3 className="font-semibold text-slate-900">{pk.title}</h3>
              <div className="text-xs text-slate-500 mt-1">Created {pk.created_at?.slice(0,10)}</div>
            </Card>
          </Link>
        ))}
        {items.length === 0 && <div className="text-sm text-slate-500">No packets yet. Open a property and generate one.</div>}
      </div>
    </div>
  );
}
